"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _productRatingsRenderHandler = _interopRequireDefault(require("./product-ratings-render-handler"));
var ProductRatings = exports["default"] = /*#__PURE__*/function () {
  function ProductRatings(validateSkuResponse) {
    var _this = this;
    (0, _classCallCheck2["default"])(this, ProductRatings);
    this.validateSkuResponse = validateSkuResponse;
    if (document.readyState === "complete" || document.readyState === "interactive") {
      this.initRenderHandler();
    } else {
      document.addEventListener("DOMContentLoaded", function () {
        return _this.initRenderHandler();
      });
    }
  }
  return (0, _createClass2["default"])(ProductRatings, [{
    key: "initRenderHandler",
    value: function () {
      var _initRenderHandler = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var productReviewsRenderHandle;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              productReviewsRenderHandle = new _productRatingsRenderHandler["default"](this.validateSkuResponse);
              _context.next = 3;
              return productReviewsRenderHandle.executeHandler();
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function initRenderHandler() {
        return _initRenderHandler.apply(this, arguments);
      }
      return initRenderHandler;
    }()
  }]);
}();
//# sourceMappingURL=product-ratings.js.map
